module.exports = __webpack_public_path__ + "assets/img/25f4-lc.svg";